<template>
    <div v-if="sectionTitleStyle === 1" class="section-title" :class="checkTextAlign">
        <h4 class="subtitle">
            <span class="theme-gradient" v-html="subtitle"/>
        </h4>
        <h2 class="title w-600" v-html="title"/>
        <p v-if="description" class="description b1" v-html="description"/>
    </div>

    <div v-else-if="sectionTitleStyle === 2" :class="`section-title-2 ${checkTextAlign}`">
        <h2 class="title">{{ title }}</h2>
    </div>

    <div v-else-if="sectionTitleStyle === 3" class="section-title section-list" :class="checkTextAlign">
        <h4 class="subtitle">
            <span class="theme-gradient" v-html="subtitle"/>
        </h4>
        <h2 class="title w-600" v-html="title"/>
        <p v-if="description" class="description b1" v-html="description"/>
        <ul data-aos="fade-up" data-aos-delay="50">
            <li v-for="(item,index) in breadList" :key="index" >
                <router-link :to="item.Url">
                    {{item.Label}}
                </router-link>
            </li>                        
            <!-- <li class="rn-breadcrumb-item active" v-for="(item,index) in breadList" :key="index">
                <router-link :to="item.Url">{{item.Label}}</router-link>
            </li> -->
        </ul>
    </div>
</template>

<script>
    import Breadcrumb from '../breadcrumb/Breadcrumb'

    export default {
        name: 'SectionTitle',
        components:{
            Breadcrumb
        },
        props: {
            subtitle: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            description: {
                type: String,
                default: null
            },
            textAlign: {
                type: String,
                default: 'left'
            },
            sectionTitleStyle: {
                type: Number,
                default: 1
            },
            breadList:[]
        },
        computed: {
            checkTextAlign() {
                if (this.textAlign === 'left') return 'text-start';
                else if (this.textAlign === 'center') return 'text-center';
                else if (this.textAlign === 'end') return 'text-end';
                else return '';
            }
        },
    }
</script>

<style scoped>
    .section-list li{
        display: inline-block;
        color: black;
        padding: 0 12px;
        position: relative;
        font-size: 16px;
        margin: 0;
    }
    .section-list li::after {
        position: absolute;
        content: "";
        top: 50%;
        transform: translateY(-50%);
        background-color: black;
        width: 5px;
        height: 5px;
        border-radius: 100%;
        opacity: 0.5;
        right: -3px;
    }
    /* .section-list li.sl-breadcrumb-item.active {
        color: black;
        opacity: 0.6;
    } */
    /* .section-list li.sl-breadcrumb-item.active::after {
        display: none;
    } */
</style>